import './screenshot-strip.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSScreenshotStripItem } from './screenshot-strip-item';

components.register({
	selector: '.gs-ScreenshotStrip-item',
	controller: GSScreenshotStripItem
});
